/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.QuoteAvailablePartsFilter = (function() {

    /**
     * Namespace QuoteAvailablePartsFilter.
     * @exports QuoteAvailablePartsFilter
     * @namespace
     */
    var QuoteAvailablePartsFilter = {};

    QuoteAvailablePartsFilter.QuoteAvailablePartsFilter = (function() {

        /**
         * Properties of a QuoteAvailablePartsFilter.
         * @memberof QuoteAvailablePartsFilter
         * @interface IQuoteAvailablePartsFilter
         * @property {string|null} [vehicleId] QuoteAvailablePartsFilter vehicleId
         * @property {string|null} [query] QuoteAvailablePartsFilter query
         * @property {string|null} [butterflyCode] QuoteAvailablePartsFilter butterflyCode
         * @property {string|null} [sortColumn] QuoteAvailablePartsFilter sortColumn
         * @property {string|null} [sortOrder] QuoteAvailablePartsFilter sortOrder
         * @property {number|null} [pageIndex] QuoteAvailablePartsFilter pageIndex
         * @property {number|null} [pageSize] QuoteAvailablePartsFilter pageSize
         * @property {string|null} [area] QuoteAvailablePartsFilter area
         */

        /**
         * Constructs a new QuoteAvailablePartsFilter.
         * @memberof QuoteAvailablePartsFilter
         * @classdesc Represents a QuoteAvailablePartsFilter.
         * @implements IQuoteAvailablePartsFilter
         * @constructor
         * @param {QuoteAvailablePartsFilter.IQuoteAvailablePartsFilter=} [p] Properties to set
         */
        function QuoteAvailablePartsFilter(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * QuoteAvailablePartsFilter vehicleId.
         * @member {string|null|undefined} vehicleId
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @instance
         */
        QuoteAvailablePartsFilter.prototype.vehicleId = null;

        /**
         * QuoteAvailablePartsFilter query.
         * @member {string|null|undefined} query
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @instance
         */
        QuoteAvailablePartsFilter.prototype.query = null;

        /**
         * QuoteAvailablePartsFilter butterflyCode.
         * @member {string|null|undefined} butterflyCode
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @instance
         */
        QuoteAvailablePartsFilter.prototype.butterflyCode = null;

        /**
         * QuoteAvailablePartsFilter sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @instance
         */
        QuoteAvailablePartsFilter.prototype.sortColumn = null;

        /**
         * QuoteAvailablePartsFilter sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @instance
         */
        QuoteAvailablePartsFilter.prototype.sortOrder = null;

        /**
         * QuoteAvailablePartsFilter pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @instance
         */
        QuoteAvailablePartsFilter.prototype.pageIndex = null;

        /**
         * QuoteAvailablePartsFilter pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @instance
         */
        QuoteAvailablePartsFilter.prototype.pageSize = null;

        /**
         * QuoteAvailablePartsFilter area.
         * @member {string|null|undefined} area
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @instance
         */
        QuoteAvailablePartsFilter.prototype.area = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * QuoteAvailablePartsFilter _vehicleId.
         * @member {"vehicleId"|undefined} _vehicleId
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailablePartsFilter.prototype, "_vehicleId", {
            get: $util.oneOfGetter($oneOfFields = ["vehicleId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailablePartsFilter _query.
         * @member {"query"|undefined} _query
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailablePartsFilter.prototype, "_query", {
            get: $util.oneOfGetter($oneOfFields = ["query"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailablePartsFilter _butterflyCode.
         * @member {"butterflyCode"|undefined} _butterflyCode
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailablePartsFilter.prototype, "_butterflyCode", {
            get: $util.oneOfGetter($oneOfFields = ["butterflyCode"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailablePartsFilter _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailablePartsFilter.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailablePartsFilter _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailablePartsFilter.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailablePartsFilter _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailablePartsFilter.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailablePartsFilter _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailablePartsFilter.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailablePartsFilter _area.
         * @member {"area"|undefined} _area
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailablePartsFilter.prototype, "_area", {
            get: $util.oneOfGetter($oneOfFields = ["area"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified QuoteAvailablePartsFilter message. Does not implicitly {@link QuoteAvailablePartsFilter.QuoteAvailablePartsFilter.verify|verify} messages.
         * @function encode
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @static
         * @param {QuoteAvailablePartsFilter.IQuoteAvailablePartsFilter} m QuoteAvailablePartsFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteAvailablePartsFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.vehicleId != null && Object.hasOwnProperty.call(m, "vehicleId"))
                w.uint32(10).string(m.vehicleId);
            if (m.query != null && Object.hasOwnProperty.call(m, "query"))
                w.uint32(18).string(m.query);
            if (m.butterflyCode != null && Object.hasOwnProperty.call(m, "butterflyCode"))
                w.uint32(26).string(m.butterflyCode);
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(34).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(42).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(48).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(56).int32(m.pageSize);
            if (m.area != null && Object.hasOwnProperty.call(m, "area"))
                w.uint32(66).string(m.area);
            return w;
        };

        /**
         * Encodes the specified QuoteAvailablePartsFilter message, length delimited. Does not implicitly {@link QuoteAvailablePartsFilter.QuoteAvailablePartsFilter.verify|verify} messages.
         * @function encodeDelimited
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @static
         * @param {QuoteAvailablePartsFilter.IQuoteAvailablePartsFilter} message QuoteAvailablePartsFilter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteAvailablePartsFilter.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a QuoteAvailablePartsFilter message from the specified reader or buffer.
         * @function decode
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {QuoteAvailablePartsFilter.QuoteAvailablePartsFilter} QuoteAvailablePartsFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteAvailablePartsFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.QuoteAvailablePartsFilter.QuoteAvailablePartsFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.vehicleId = r.string();
                    break;
                case 2:
                    m.query = r.string();
                    break;
                case 3:
                    m.butterflyCode = r.string();
                    break;
                case 4:
                    m.sortColumn = r.string();
                    break;
                case 5:
                    m.sortOrder = r.string();
                    break;
                case 6:
                    m.pageIndex = r.int32();
                    break;
                case 7:
                    m.pageSize = r.int32();
                    break;
                case 8:
                    m.area = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a QuoteAvailablePartsFilter message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof QuoteAvailablePartsFilter.QuoteAvailablePartsFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {QuoteAvailablePartsFilter.QuoteAvailablePartsFilter} QuoteAvailablePartsFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteAvailablePartsFilter.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return QuoteAvailablePartsFilter;
    })();

    return QuoteAvailablePartsFilter;
})();

module.exports = $root;
